require('lazysizes');
require('lazysizes/plugins/bgset/ls.bgset.js');
require('lazysizes/plugins/respimg/ls.respimg.js');

/**
 * Import JS polyfills
 */
require('nodelist-foreach-polyfill');


const jquery = require('jquery');

const { scrollTo } = require('./Tools.js');

const loadMore = require('./loadMore.js');
const navigation = require('./navigation.js');
const mitmachenFlag = require('./mitmachenFlag');
const frontpageHeaderAnimation = require('./frontpageHeaderAnimation');

// Add throttled resize events to window object
const throttle = function(type, name) {
  let running = false;

  let func = function() {
    if (running) return;
    running = true;

    window.requestAnimationFrame(() => {
      window.dispatchEvent(new CustomEvent(name));
      running = false;
    });
  };

  window.addEventListener(type, func);
};

throttle('resize', 'throttledResize');
throttle('scroll', 'throttledScroll');


document.addEventListener('DOMContentLoaded', () => {
  openSocialLinksInPopup();
  // scrollDownOnFrontpage();
  frontpageHeaderAnimation();
  // mitmachenFlag();
  loadMore();
  navigation();
  scrollToAnchorLink();
  // getInstagramFeed();
  scrollUpFromFooter();

  // Detect if user interaction is via touch
  // https://medium.com/@david.gilbertson/the-only-way-to-detect-touch-with-javascript-7791a3346685
  window.addEventListener('touchstart', function onFirstTouch() {
    var body = document.querySelector('body');
    body.classList.add('is-touch');

    window.userCanTouch = true;
    window.dispatchEvent(new Event('isTouchDetected'));

    window.removeEventListener('touchstart', onFirstTouch, false);
  }, false);

  window.addEventListener('mouseover', function onFirstHover() {
    window.userCanHover = true;

    window.removeEventListener('mouseover', onFirstHover, false);
  }, false);


  window.dispatchEvent(new Event('scroll'));
  window.dispatchEvent(new Event('resize'));
});


const scrollDownOnFrontpage = function scrollDownOnFrontpage() {
  // Scroll to themen when frontpage banner is clicked
  const frontBanner = document.querySelector('body.home .front-header-wrapper');
  if (!frontBanner) return;

  const target = document.querySelector('article.home-featured');

  frontBanner.addEventListener('click', (e) => {
    scrollTo(jquery(target).offset().top - 20, 600, 'easeOutQuad');
  });
};


const scrollToAnchorLink = function scrollToAnchorLink() {
  // Only run this on wir-jusos page
  if (window.location.pathname !== '/wir-jusos/') return;

  if (! window.location.has) return;

  const target = document.querySelector(window.location.hash);


  if (!target) return;

  scrollTo(jquery(target).offset().top - 20, 600, 'easeOutQuad');
};


const scrollUpFromFooter = function scrollUpFromFooter() {
  const el = document.querySelector('.footer__logo');
  el.addEventListener('click', (e) => {
    e.preventDefault();
    scrollTo(0, 600, 'easeOutQuad');
  });
}

const openSocialLinksInPopup = function openSocialLinksInPopup() {
  // Open Social media share links in pop-up window
  const socialLinks = document.querySelectorAll('.share .open-popup a');
  socialLinks.forEach(item => item.addEventListener('click', e => {
    const link = e.target.attributes.getNamedItem('href').value;
    const posLeft = window.innerWidth / 2 - 300;
    const posTop = window.innerHeight / 2 - 250;

    window.open(link, "_blank", `toolbar=yes,scrollbars=yes,resizable=yes,top=${posTop},left=${posLeft},width=600,height=500`);
  }));
};


const getInstagramFeed = function getInstagramFeed() {
  const isHome = document.querySelector('body.home');
  if (!isHome) return;

  jquery.ajax(ajaxUrl, {
    data: {
      action: 'get-instagram-feed'
    },
    success(response, status) {
      let $content = jquery.parseHTML(response.data);
      $content = jquery($content);
      $content.append(jquery('<script async defer src="//platform.instagram.com/en_US/embeds.js"></script>'));

      jquery('.social-media-feeds .instagram-feed').append($content);
    }
  });
};
